import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as _ from "underscore";
import { ShiftPlanner } from "../../../../../Actions/commonAction";
import viewMetaData from "./ViewMetaData";
import SectionHeaderExtraSmall from "../../../../../Component/Headers/sectionHeaderExtraSmall";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

let viewModeElement = [];

const generateElement = (objElement, values) => {
  console.log("objElement, values: ", objElement, values);
  return (
    <div>
      <p className={objElement.headercss}>{objElement.header}</p>
      <p className={objElement.subheadercss}>{objElement.subheader}</p>
      <p style={{ textAlign: "justify" }}>{values}</p>
    </div>
  );
};

function generateData(metaObj, viewData) {
  if (!viewData) {
    return viewModeElement;
  }
  let dynamicVal = "";
  let jsonVal = "";
  let isValidobj = true;

  Object.keys(viewData)
    .sort()
    .map((result) => {
      isValidobj = true;
      if (viewData[result] != null) {
        console.log(viewData[result]);
        if (result == "weekoffdays") {
          const weekdays = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ];
          //   const weeks = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"];
          if (viewData[result].length > 0) {
            const weeklyoffs = _.filter(
              viewData[result],
              (v) => v.weekoffdetailid > -1,
            );
            const weekarray = {};
            weekarray.weekoffdata = [];
            weeklyoffs.forEach((item, i) => {
              const week1 =
                item.week1 == 1
                  ? "Week 1: Half Day"
                  : item.week1 == 2
                  ? "Week 1: Full Day"
                  : ""; /* : "Week 1: No Weekoff" */
              const week2 =
                item.week2 == 1
                  ? "Week 2: Half Day"
                  : item.week2 == 2
                  ? "Week 2: Full Day"
                  : ""; /* "Week 2: No Weekoff" */
              const week3 =
                item.week3 == 1
                  ? "Week 3: Half Day"
                  : item.week3 == 2
                  ? "Week 3: Full Day"
                  : ""; /* "Week 3: No Weekoff" */
              const week4 =
                item.lastweek == 2
                  ? "Week 4 : Holiday"
                  : item.week4 == 1
                  ? "Week 4: Half Day"
                  : item.week4 == 2
                  ? "Week 4: Full Day"
                  : "";
              /* "Week 4: No Weekoff" */
              const week5 =
                item.lastweek == 2
                  ? "Week 5 : Holiday"
                  : item.week5 == 1
                  ? "Week 5: Half Day"
                  : item.week5 == 2
                  ? "Week 5: Full Day"
                  : "";
              /* "Week 5: No Weekoff" */
              let weekinfo = {};
              if (
                week1 != "" ||
                week2 != "" ||
                week3 != "" ||
                week4 != "" ||
                week5 != ""
              ) {
                weekinfo = {
                  weekday: weekdays[item.weekdayid - 1],
                  Weeklist:
                    (week1 != "" ? `${week1}, ` : "") +
                    (week2 != "" ? `${week2}, ` : "") +
                    (week3 != "" ? `${week3}, ` : "") +
                    (week4 != "" ? `${week4}, ` : "") +
                    (week5 != "" ? week5 : "") /* + ", " + lastweek */,
                };
              }
              if (i == 0) {
                generateData(metaObj.weekoffdata[0], weekinfo);
              } else {
                generateData(metaObj.weekoffdata[1], weekinfo);
              }
            });
          }
        } else if (Array.isArray(viewData[result])) {
          if (metaObj[result] != undefined) {
            generateData(metaObj[result], viewData[result]);
          }
        } else if (typeof viewData[result] === "object") {
          if (metaObj[0] != undefined) {
            generateData(metaObj[0], viewData[result]);
          }
        } else if (
          typeof viewData[result] === "string" ||
          typeof viewData[result] === "boolean" ||
          typeof viewData[result] === "number"
        ) {
          if (metaObj[result] != undefined) {
            if (Array.isArray(metaObj[result])) {
              if (metaObj[result][0][viewData[result]] != undefined) {
                if (isValidobj) {
                  const nested = generateElement(
                    metaObj[result][0][viewData[result]],
                    metaObj[result][0][viewData[result]].values,
                  );
                  viewModeElement.push(nested);
                }
              }
            } else if (typeof metaObj[result] === "object") {
              if (typeof viewData[result] === "boolean") {
                dynamicVal = viewData[result] ? "Yes" : "No";
                if (dynamicVal == "No") {
                  isValidobj = false;
                }
              } else {
                dynamicVal = viewData[result];
                if (
                  dynamicVal == null ||
                  dynamicVal == "0" ||
                  dynamicVal == 0 ||
                  dynamicVal == "" ||
                  dynamicVal == "00:00:00"
                ) {
                  isValidobj = false;
                }
              }
              jsonVal = metaObj[result].values;
              jsonVal = jsonVal.replace("<val>", dynamicVal);

              if (isValidobj) {
                const nested = generateElement(metaObj[result], jsonVal);
                viewModeElement.push(nested);
              }
            }
          }
        }
      }
      return viewModeElement;
    });
  return viewModeElement;
}

class Preview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      weekoffPlannerReducer: {},
      Metadata: {},
      elementList: [],
    };
  }

  componentDidMount() {
    this.props.onRef({
      nextButtonLabel: "Save",
    });
    const { weekoffPlannerReducer } = this.props;
    const viewmodejson = viewMetaData;
    viewModeElement = [];
    const elementArray = generateData(viewmodejson, weekoffPlannerReducer);
    this.setState({
      weekoffPlannerReducer,
      Metadata: viewmodejson,
      elementList: elementArray,
    });
  }

  OnCancel() {
    this.props.Cancel(true);
  }

  render() {
    const language = this.props.Language.allshiftplanner;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="padding-30 ">
          <div className="inner-wrapper opaque">
            {this.state.elementList}
            <SectionHeaderExtraSmall header="Note: If specified offs for last week seperately, it will override the selection for 4th/5th weeks." />
          </div>
        </div>
      </IntlProvider>
    );
  }
}

Preview.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  weekoffPlannerReducer: state.weekoffPlannerReducer,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ShiftPlanner: (data) => ShiftPlanner(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(Preview)));
